module.exports = __webpack_public_path__ + "media/images/brand/app_text-b513a8c19e23a1842f8d130d0af8b9e2.png";